import { Button, Col, Form, Row, Upload, notification, Checkbox } from 'antd'
import { LogoutOutlined } from '@ant-design/icons'
import SignatureCanvas from 'react-signature-canvas';
import React, { useEffect, useRef, useState } from 'react'
import { authService, profileService } from '../../services';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { changeDocumentTitle } from '../../utils/title';


function TermAndCondition({ onSubmit }) {
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const signatureRef = useRef(null);
  const [user, setUser] = useState([])
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState("show")
  const [check, setCheck] = useState(false)
  const [fileList, setFileList] = useState([]);

  const [passportFile, setPassportFile] = useState(null);


  const handleSignatureEnd = () => {
    form.setFieldsValue({ signature: "signed" });
    form.validateFields(["signature"]);
  };

  const [fileName, setFileName] = useState("No file chosen");

  const handleChange = (info) => {
    // Only keep the latest file
    const latestFileList = info.fileList.slice(-1);
    setFileList(latestFileList);

    if (latestFileList.length > 0) {
      setFileName(latestFileList[0].name);
      setPassportFile(latestFileList[0].originFileObj);
    } else {
      setFileName("No file chosen");
      setPassportFile(null);
    }
  };

  const clear = () => {
    if (!signatureRef.current) return;

    const sig = signatureRef.current;
    const canvas = sig.getCanvas();
    const ctx = canvas.getContext("2d");

    // Get current CSS size
    const { width, height } = canvas.getBoundingClientRect();

    // Ensure the canvas resolution matches the visual size
    canvas.width = width * window.devicePixelRatio;
    canvas.height = height * window.devicePixelRatio;

    // Reset transformation to prevent distortion
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio);

    // Fully clear the drawing surface
    ctx.clearRect(0, 0, width, height);

    // Clear internal signature data
    sig.clear();

    // Reset form field
    form.setFieldsValue({ signature: undefined });
  };

  const save = async () => {
    setLoading(true);
    const canvas = signatureRef.current.getTrimmedCanvas();

    if (!canvas) {
      notification.error({
        message: "Signature is required!",
        placement: "topRight"
      });
      setLoading(false);
      return;
    }

    // Wrap toBlob in a promise
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));

    if (!blob) {
      notification.error({
        message: "Failed to get signature blob!",
        placement: "topRight",
      });
      setLoading(false);
      return;
    }

    const formData = new FormData();
    const file = new File([blob], "signature.png", { type: "image/png" });
    formData.append("signed", file);

    if (passportFile) {
      formData.append("image", passportFile);
    } else {
      notification.error({
        message: "Passport / POA / BOS file is required!",
        placement: "topRight",
      });
      setLoading(false);
      return;
    }

    try {
      const response = await authService.agreement(formData);

      if (response.success) {
        localStorage.setItem("isAllowed", true);
        notification.success({
          message: response.message,
          placement: "topRight",
        });
        onSubmit();
        navigate('/'); // ✅ This will now reliably redirect
      } else {
        notification.error({
          message: response.message || "Something went wrong",
          placement: "topRight",
        });
      }
    } catch (err) {
      console.error(err);
      notification.error({
        message: "Failed to save agreement",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const loadAuthUser = async () => {
    const { success, data } = await profileService.fetchLoggedUser()
    if (success) {

      if (data.isContractSign) {
        navigate('/');
      }
      setUser(data)
    }
  }

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    localStorage.removeItem("user");
    localStorage.removeItem("isAllowed");
    navigate("/login");
  }

  useEffect(() => {
    changeDocumentTitle("Terms & Conditions");
    loadAuthUser()
    if (signatureRef.current) {
      const canvas = signatureRef.current.getCanvas();
      const ctx = canvas.getContext('2d');
      const dpr = window.devicePixelRatio || 1;

      // Adjust canvas size for DPR
      const width = canvas.clientWidth * dpr;
      const height = canvas.clientHeight * dpr;

      canvas.width = width;
      canvas.height = height;

      // Scale context to fix drawing position
      ctx.scale(dpr, dpr);
    }
  }, []);

  const handleStatus = () => {
    setStatus((prev) => (prev === "show" ? "hide" : "show"));
  }

  return (
    <div className=' '>
      <div className='flex justify-center w-full border-b py-4'>
        <div className='w-[68%] flex justify-between items-end'>
          <div className='flex justify-center gap-2 items-end'>
            <img src="/images/ctrade-logo2.png" alt="" style={{ width: 130, height: 80 }} />
            <div>
              <h1 className='p-0 m-0'>Negotiated Rate Agreement</h1>
              <p className='p-0 m-0 text-[11px] text-[#6A7282]'>CTRADE USA INC, customer portal</p>
            </div>
          </div>
          <Button variant='outlined' color='primary' onClick={logout}><LogoutOutlined />Log out</Button>
        </div>
      </div>
      <div className='max-w-7xl mx-auto mt-4'>
        <div className='flex w-full gap-5' >
          <div className='flex flex-col w-[70%]'>
            <div style={{ border: "1px solid #E5E7EB", borderRadius: "16px" }} className=' h-auto'>
              <div style={{ fontSize: '14px', display: "flex", flexDirection: "column" }} className='leading-6 text-[#1E2939] p-6'>
                <p className='border-b'>
                  This contract is made by and between: <span className='font-semibold'>CTRADE USA INC</span> (As
                  SHIPPING/FORWARDING/EXPORTER AGENT ONLY) and <span className='font-semibold'>{user?.name}</span> on {dayjs(user?.created_at).format("DD-MM-YYYY")} (as a
                  shipper) for shipping requirements on agreed price according to email applied
                  from the date of services offer / cargo delivered or handled.</p>
                <p className='font-semibold'>
                  TERMS AND CONDITIONS:
                </p>
                <ol style={{ padding: '0 15px 0 25px', listStyleType: "decimal", textAlign: "justify", fontSize: 14 }}>
                  <li>
                    Unless otherwise noted, all ocean freight quotations subject to third party/
                    are: valid For 30 days From the date of original quotation, subject to
                    equipment availability, subject to any and all tariff additions, valid at time
                    initial shipment is received. Inland Freight quotations are: subject to third
                    party increases valid at time initial shipment is received, subject to any fuel
                    surcharges valid at time initial shipment is received, subject to weight
                    limitations and weight distribution requirements in accordance with the
                    local and national rules and regulations of the country (ies) of transit,
                    subject to availability of inland carrier at time of booking. Loading, lashing,
                    securing, blocking and bracing of cargo is For shipper's account. Carrier
                    reserves the right to stow cargo in the best interest of the Vessel and in
                    compliance with local, national and international rules, regulations and
                    conventions. On deck shipments at shipper’s risk. Dangerous cargo, as
                    defined by 49 CFR or the IMDG Code, is subject to the line’s approval at time
                    of booking. Kindly note all vessel dates are subject to changes. Equipment is
                    subject to availability. See C TRADE USA INC ORDER FORM for shipment
                    details to which such rate will apply. Service provided to this NRA is subject
                    to Carrier's governing rules tariff, which is accessible at in compliance with
                    FMC Regulations as provided in 46 CFR 532.7
                  </li>
                  <li>
                    INSURACE: We advise all our customers to put insurance on their                  shipments as there is no insurance on container.

                  </li>
                  <li>
                    Customs hold and inspection: C TRADE USA INC will not be responsible For
                    any delay or Costs incurred due to custom investigation or hold. See bill of Lading Terms 1-34 in Rule 8 of carriers governing rules tariff.
                  </li>
                  <li>
                    RORO: Vehicle shipments should be empty and operational.
                  </li>
                  <li>
                    PAYMENT: We advise all customers to pay on time as agreed 15 days from
                    the date of invoice. Please allow 3-7 business days before we can process
                    your payment and send you your release. C TRADE USA INC is not
                    responsible For any demurrage or detention occurs at destination due to
                    late payment.
                  </li>
                  <li>ETA and ETD: Alll dates of sailing and arriving are estimated and C TRADE
                    USA INC will not be responsible for any delay. See bill of Lading Terms 1-34
                    in Rule 8 of carriers governing rules tariff.
                  </li>
                  <li>
                    Packing List: Customer is responsible for providing C TRADE USA INC a
                    proper packing list of goods to be loaded at customer location. C TRADE
                    USA INC will not be responsible for any fines, Fees and penalties due to
                    failure to provide C TRADE USA INC a proper packing list of goods.
                    Customer will be responsible for Charges incurred due to incorrect packing
                    list.
                  </li>
                  <li>
                    Declaring Values: C TRADE USA INC requires that the shipper provides
                    values for goods being shipped for Documentary/ Customs purposes.
                    Customer should do their best to provide as accurate information as
                    possible.
                  </li>
                  <li>
                    CTRADE USA INC WILL NOT REPSONSIBLE FOR ANY DELAY IN RELEASE OF
                    STORAGE OCCURRED ON SHIPMENT ON FACILITATION OF THIRD PARTY.
                  </li>
                  <li>
                    Customer will be responsible for Charges incurred due to incorrect values or holds caused.
                  </li>
                  <li>
                    See C TRADE USA INC ORDER FORM for shipment details to which such rate
                    will apply.
                  </li>
                  <li>
                    Any cause of vessel delay / dates change/custom hold title resulting
                    rollovers/per deim CTRADE USA INC will not be responsible For any
                    additional charges occurs on same.
                  </li>
                  <li>
                    STORAGE POLICY IS FIRM Storage Policy: 15 Days Free at all Facilities
                    there after $ 10/Day/Car from the Day of receiving in and out charges will be
                    $ 100/. Subject to storage charge
                  </li>
                  <li>
                    Documentation for Title validation: Customer is responsible to provide the all
                    the relevant documents like BOS, notarized POA, passport copy etc. to Fulfill
                    the US Customs requirement. If customs holds the documents and in case of
                    any rollover CTRADE USA INC will not be responsible.
                  </li>
                </ol>
              </div>
              <div className='border-t'>
                <div className='p-6'>
                  <h2 className='font-normal text-sm'>Acceptance</h2>
                  <p className='font-normal text-sm text-[#4A5565]'>Read all terms carefully, then sign and confirm <span className='text-red-600'>Signature and file upload are mandatory.</span></p>
                  <Form layout="vertical" form={form} onFinish={save} style={{ textAlign: "right", width: "100%", }}>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Form.Item
                          label={
                            <p className='text-[#99A1AF]'>
                              Authorized Signatory (draw with mouse or finger)
                            </p>
                          }
                          name="signature"
                        >
                          <div
                            style={{
                              position: 'relative',
                              border: '1px dashed #ccc',
                              borderRadius: '14px',
                              backgroundColor: '#f5f5f5', // light gray background
                              height: '200px',
                              overflow: 'hidden',
                              padding: '20px 20px 50px',
                              boxSizing: 'border-box',
                            }}
                          >
                            {/* White area for signature only */}
                            <div
                              style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '10px',
                                height: '100%',
                                width: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              <SignatureCanvas
                                ref={signatureRef}
                                penColor="#808080"
                                onEnd={handleSignatureEnd}
                                minWidth={1}
                                maxWidth={3}
                                canvasProps={{
                                  // width: 500,
                                  // height: 100,
                                  className: 'sigCanvas',
                                  style: {
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'white',
                                  },
                                }}
                              />
                            </div>

                            {/* Clear button INSIDE the border, bottom-left corner */}
                            <Button
                              size="middle"
                              onClick={clear}
                              style={{
                                position: 'absolute',
                                bottom: '5px',
                                left: '15px',
                                backgroundColor: 'white',
                                border: '1px solid #D1D5DC',
                                borderRadius: '8px',
                                zIndex: 10, // 🔥 ensures button is clickable above canvas
                              }}
                            >
                              Clear
                            </Button>
                          </div>
                        </Form.Item>
                      </Col>

                      <Col span={12}>
                        <Form.Item
                          label={
                            <p className="text-[#99A1AF]">
                              <span className="text-[#6A7282]">
                                Upload Passport Copy / Notarized POA / BOS / Company ID
                              </span>{" "}
                              Customer is responsible to upload these documents for US customs
                              validation. If customs holds the documents and in case of rollover
                              C TRADE USA INC will not be responsible.
                            </p>
                          }
                          name="passport"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <Upload
                              beforeUpload={() => false} // prevent auto upload
                              onChange={handleChange}
                              showUploadList={false} // hide default list
                              fileList={fileList} // controlled file list
                              accept="image/*"
                            >
                              <Button type="primary" style={{ borderRadius: "6px", height: "38px" }}>
                                Choose File
                              </Button>
                            </Upload>

                            <span
                              style={{
                                marginTop: "4px",
                                fontSize: "12px",
                                color: "#888",
                                textAlign: "left", // extra safety
                              }}
                            >
                              {fileName}
                            </span>
                          </div>
                        </Form.Item>


                        <div className='flex justify-start gap-3'>
                          <Checkbox onChange={(e) => setCheck(e.target.checked)} />I have read and accept all terms and conditions.
                        </div>
                      </Col>

                    </Row>
                    <div className='w-full mt-2 text-left'>
                      <Button
                        loading={loading}
                        disabled={check ? false : true}
                        htmlType="submit"
                        style={{
                          width: '20%',
                          padding: '20px',
                        }}>
                        Confirm & Save
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <p className='py-3 text-sm text-[#717988] mb-6'>PORT Conditions: CTRADE USA INC will not be responsible in case of any unforeseen reason at Houston Port that affects the shipping operations</p>
          </div>

          <div className='flex flex-col gap-5 w-[30%]'>

            <div style={{ border: "1px solid #E5E7EB", borderRadius: "16px" }} className='p-5 h-auto'>
              <div className='flex justify-between'>
                <h1 className='text-sm' >Document Summary</h1>
                <Button size='small' onClick={handleStatus} className='border p-1 rounded-md text-center' >{status === "hide" ? 'Hide' : 'Show'}</Button>
              </div>
              <div
                className={`transition-all duration-700 ease-in-out overflow-hidden ${status === "show" ? "max-h-[800px] opacity-100" : "max-h-0 opacity-0"
                  }`}
              >
                <ul className='leading-6' style={{ padding: '0 15px 0 25px', listStyleType: "initial", textAlign: "justify", fontSize: 13 }}>
                  <li>Invoice due 15 days, processing time 3 to 7 business days</li>
                  <li>Insurance by shipper, not covered by C TRADE USA INC</li>
                  <li>Storage, 15 days free, then 10 USD per day per car</li>
                  <li>All dates are estimates, no guarantees on ETA or ETD</li>
                  <li>Customer provides accurate packing list and values</li>
                </ul>
              </div>
            </div>

            <div style={{ border: "1px solid #E5E7EB", borderRadius: "16px" }} className='p-5 h-auto'>
              <h1 className='text-sm mb-5' >Parties</h1>
              <div className="flex flex-col w-full gap-5" style={{ textAlign: "justify", fontSize: 13 }}>
                {/* Row 1 */}
                <div className="flex justify-between">
                  <span className="text-[#606A72] w-[35%]">Company</span>
                  <span className="text-[#333333] font-medium uppercase w-[50%]">CTRade USA Inc</span>
                </div>

                {/* Row 2 */}
                <div className="flex justify-between">
                  <span className="text-[#606A72] w-[35%]">Shipper</span>
                  <span className="text-[#333333] font-medium w-[50%]">US TRANS LLC</span>
                </div>

                {/* Row 3 */}
                <div className="flex justify-between">
                  <span className="text-[#606A72] w-[35%]">Agreement Date</span>
                  <span className="text-[#333333] font-medium w-[50%]">27 Oct 2022</span>
                </div>

                {/* Row 4 */}
                <div className="flex justify-between">
                  <span className="text-[#606A72] w-[35%]">Prepared</span>
                  <span className="text-[#333333] font-medium w-[50%]">10/22/2025</span>
                </div>

              </div>
            </div>

            <div className="border  h-auto rounded-xl py-4 px-5 bg-white  w-full">
              <h1 className='text-sm'>Need Help</h1>
              <div className=" text-sm text-[#606A72]">
                <span>Have a question, contact <a
                  href="mailto:ctrade@ctrade.us"
                  className="text-primary underline"
                >
                  info@ctrade.us
                </a>{" "}or call +1 832 476 2242</span>
              </div>
            </div>

          </div>

        </div>
      </div>

      <style>
        {`ol li {
          margin-bottom: 15px
        }`}
      </style>
    </div >
  )
}

export default TermAndCondition
